export const formatDate = (
  d: Date | null | undefined,
  format: 'short' | 'long' | 'compact' | 'dateTime' = 'short',
  fallback: string = ''
): string => {
  if (!(d instanceof Date) || isNaN(d.getTime())) return fallback;

  const pad = (n: number) => String(n).padStart(2, '0');
  const day = d.getDate();
  const month = d.getMonth() + 1; // zero-based
  const year = d.getFullYear();

  if ([day, month, year].some(n => isNaN(n))) return fallback;

  if (format === 'long') {
    return new Date(d).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  }

  if (format === 'dateTime') {
    const datePart = new Date(d).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
    const timePart = new Date(d).toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    return `${datePart} ${timePart}`;
  }

  if (format === 'compact') {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    return `${months[d.getMonth()]} ${day}, ${year.toString().slice(-2)}`;
  }

  return `${pad(day)}.${pad(month)}.${year}`;
};
